export default "__VITE_ASSET__hRAmGCFZ__"